import React from "react";
import PropTypes from "prop-types";
import PasswordComponent from "./labeledinput/PasswordComponent";
import AboutYouComponent from "./labeledinput/AboutYouComponent";
import TradeClearComponent from "./labeledinput/TradeClearComponent";
import CustomerFeedbackComponent from "./labeledinput/CustomerFeedbackComponent";
import SecurityQuestionsComponent from "./labeledinput/SecurityQuestionsComponent";
import PolicyAgreementComponent from "./labeledinput/PolicyAgreementComponent";

import {isFormSubmittable, setupOnExtractData} from "../../util/FormUtil"
import WorkInfoComponent from "./labeledinput/WorkInfoComponent";
import HasBrokerComponent from "./labeledinput/HasBrokerComponent";
class FederationUserDataComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setExtractAboutYou = this.setExtractAboutYou.bind(this);
        this.setExtractCustomerFeedback = this.setExtractCustomerFeedback.bind(this);
        this.setExtractPassword = this.setExtractPassword.bind(this);
        this.setExtractPolicyAgree = this.setExtractPolicyAgree.bind(this);
        this.setExtractSecQnA = this.setExtractSecQnA.bind(this);
        this.setExtractTradeClear = this.setExtractTradeClear.bind(this);
        this.setExtractWorkInfo = this.setExtractWorkInfo.bind(this);
        this.setExtractHasBrokerInfo = this.setExtractHasBrokerInfo.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    extractData(){
        const result = {
            aboutYouInfo: this.extractAboutYou(),
            tradeClearInfo: this.extractTradeClear(),
            customerFeedbackInfo: this.extractCustomerFeedback(),
            policyAgreementInfo: this.extractPolicyAgree(),
            hasBrokerInfo: this.extractHasBrokerInfo ? this.extractHasBrokerInfo() : {},
            workInfo: this.extractWorkInfo(),
            securityQuestionsInfo: this.extractSecQnA()
        };
        const {includePassword} = this.props;
        if (includePassword){
            result.passwordInfo = this.extractPassword();
        }
        return result;
    };


    setExtractPassword(func){
        this.extractPassword = func;
    }

    setExtractAboutYou(func){
        this.extractAboutYou = func;
    }

    setExtractTradeClear(func){
        this.extractTradeClear = func;
    }

    setExtractCustomerFeedback(func){
        this.extractCustomerFeedback = func;
    }

    setExtractWorkInfo(func){
        this.extractWorkInfo = func;
    }

    setExtractSecQnA(func){
        this.extractSecQnA = func;
    }

    setExtractPolicyAgree(func){
        this.extractPolicyAgree = func;
    }

    setExtractHasBrokerInfo(func){
        this.extractHasBrokerInfo = func;
    }


    render(){
        const {data, metadata, conditionalFed, userDataInit, requireSecurityQnA, includePassword, onCancel, onSubmit,
            userDataService, setFormState, email, phoneRequired=true, allowSkipPhoneInput, onError, skipIpStackServiceCall} = this.props;
        const submitDisabled = ! isFormSubmittable(metadata);
        return (
            <div>
                <h2>Complete your profile</h2>
                {
                    includePassword &&
                    <PasswordComponent
                        data={data}
                        setFormState={setFormState}
                        email={email}
                        metadata={metadata}
                        userDataService={userDataService}
                        onExtractData={this.setExtractPassword}
                        conditionalFed={conditionalFed}
                    />
                }

                <AboutYouComponent
                    data={data}
                    metadata={metadata}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    hideCountry={true}
                    onExtractData={this.setExtractAboutYou}
                    userDataService={userDataService}
                    allowSkipPhoneInput={allowSkipPhoneInput}
                />

                <TradeClearComponent
                    data={data}
                    metadata={metadata}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    onExtractData={this.setExtractTradeClear}
                />
                <HasBrokerComponent
                    data={data}
                    metadata={metadata}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    onExtractData={this.setExtractHasBrokerInfo}
                />
                <CustomerFeedbackComponent
                    data={data}
                    metadata={metadata}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    onExtractData={this.setExtractCustomerFeedback}
                />
                <WorkInfoComponent
                    data={data}
                    metadata={metadata}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    userDataService={userDataService}
                    onExtractData={this.setExtractWorkInfo}
                    phoneRequired={phoneRequired}
                    allowSkipPhoneInput={allowSkipPhoneInput}
                    countryCodeWidth="20"
                    onError={onError}
                    skipIpStackServiceCall={skipIpStackServiceCall}
                />

                <SecurityQuestionsComponent
                    data={data}
                    metadata={metadata}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    required={requireSecurityQnA}
                    onExtractData={this.setExtractSecQnA}
                />

                <PolicyAgreementComponent
                    data={data}
                    userDataInit={userDataInit}
                    metadata={metadata}
                    setFormState={setFormState}
                    onExtractData={this.setExtractPolicyAgree}
                />
                <div className="text--center">
                    {
                        onCancel &&
                        <button className="btn btn--link" onClick={onCancel}>Cancel</button>
                    }
                    <button disabled={submitDisabled} onClick={onSubmit}
                            className="btn push-half--left">Continue
                    </button>
                </div>
            </div>

        );
    }
}

FederationUserDataComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.object.isRequired,
    requireSecurityQnA: PropTypes.bool.isRequired,
    includePassword: PropTypes.bool.isRequired,
    setFormState: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    email: PropTypes.string,
    onExtractData: PropTypes.func,
    phoneRequired: PropTypes.bool,
    conditionalFed: PropTypes.bool,
    onError: PropTypes.func.isRequired
};

export default FederationUserDataComponent;